import config from "./config";
var axios = config();

export default {
  getApplicationTypes() {
    return axios.get("/api/ApplicationTypes/GetApplicationTypes", {});
  }
};
